import Navbar from './Navbar';
import HomeIcon from '@material-ui/icons/Home';

const navbarOptions = [
  {
    _id: 'home',
    label: 'Home',
  },
  {
    _id:'features',
    label:'Tutorial',
  },

  {
    _id:'about',
    label:'About',
  },
  {

    _id:'overview',
    label:'Overview',
  },

  {

    _id:'contact',
    label:'Contact',
  }

  /*
  {
    _id:'signin',
    label:'Sign in',
    style:{
      fontWeight:'bold',
      border:'3px solid white',
    },
    hoverClass:"signin-hover"
  }
  */


]

export default function WelcomeSceneNavbar({
  onNavbarClick,
  setSubscene,
  subscene,
}){

  return (
    <div style={{
      position:'sticky',
      top:0, 
      left:0,
      minHeight:50,
      height:50,
      width:'100%',
      background:'white',
      //background:'rgb(1, 72, 140)',
      color:'black',
      //borderBottom:'1px solid #ccc',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      overflowX:'auto',
      zIndex:20,
    }}>
      {false && <div style={{
        //marginLeft:20,
      }}
        onClick={() => setSubscene("home")}
        class="underline-hoverable selectable clickable black-hover">
        {/*<HomeIcon className={`black-hover`} 
          style={{
            color:(subscene === "home" ? "#444": '#aaa'),
            fontSize:28,

          }}/>*/}
      </div>}
      {/*<div class="flex-expand"/>*/}
      <Navbar 
        onSelect={onNavbarClick}
        selected={subscene}
        style={{ 
          color:'#222', 
          marginLeft:25,
          //boxSizing:'border-box',
          //marginLeft:25, 
          //outline:'1px solid blue',
          //fontVariant:'small-caps',
          fontWeight:200,
          fontSize:18,
          //fontSize:'150%',
        }}
        hoverClass={"black-hover"}
        selectedClass={"bold"}
        spread={false} 
      options={navbarOptions}/>
      <div style={{width: 25}} />
      {/*<div style={{width:100}}/>*/}
    </div>
  )
}
